import { render, staticRenderFns } from "./full-dom.vue?vue&type=template&id=4a0a8d0c&"
var script = {}
import style0 from "./full-dom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports